import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { computed, onBeforeUnmount } from "vue";
  import VuePictureCropper, { cropper } from "vue-picture-cropper";

  interface Props {
    isShowModal: boolean;
    image: string;
    aspectRatio: number | null;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageCropperModal',
  props: {
    isShowModal: { type: Boolean },
    image: {},
    aspectRatio: { default: 16 / 9 }
  },
  emits: ["onCropImage", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const boxStyle = {
    width: "100%",
    height: "700px",
    backgroundColor: "#f8f8f8",
    margin: "auto",
  };

  const options = computed(() => {
    const aspectRatio = props.aspectRatio;

    return {
      viewMode: 1,
      dragMode: "crop",
      aspectRatio: aspectRatio,
    };
  });
  const onCropImage = async () => {
    if (!cropper) {
      return;
    }

    const file = await cropper.getFile({
      maxHeight: 2250,
      maxWidth: 4000,
    });

    emits("onCropImage", file);
    cropper.destroy();
  };
  const reset = () => cropper?.reset();
  const close = () => {
    cropper?.destroy();
    emits("close");
  };
  const clear = () => cropper?.clear();

  onBeforeUnmount(() => {
    cropper?.destroy();
  });

const __returned__ = { emits, props, boxStyle, options, onCropImage, reset, close, clear, Modal, computed, onBeforeUnmount, get VuePictureCropper() { return VuePictureCropper }, get cropper() { return cropper } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})